import { useCallback, useEffect, useState } from 'react';

export function normalizePath(pathname) {
  const raw = String(pathname || '/').split('?')[0].split('#')[0];
  if (!raw || raw === '/') return '/';
  return raw.replace(/\/+$/, '') || '/';
}

export function usePath() {
  const [path, setPath] = useState(() =>
    typeof window === 'undefined' ? '/' : normalizePath(window.location.pathname)
  );

  useEffect(() => {
    const sync = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);

  const navigate = useCallback((to, { replace = false } = {}) => {
    const href = String(to || '/');
    const hash = href.includes('#') ? href.slice(href.indexOf('#') + 1) : '';
    const next = normalizePath(href);
    if (replace) window.history.replaceState({}, '', href);
    else window.history.pushState({}, '', href);
    setPath(next);
    if (hash) {
      requestAnimationFrame(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return;
    }
    window.scrollTo(0, 0);
  }, []);

  return [path, navigate];
}
